const request = {}

request.createRequest = function (params) {
  return params
  // return {
  //   organizationName: params.organizationName,
  //   countryId: params.countryId,
  //   postalCode: params.postalCode,
  //   regionId: params.regionId,
  //   region: params.region,
  //   address1: params.address1,
  //   address2: params.address2,
  //   phoneNumberCountryId: params.phoneNumberCountryId,
  //   phoneNumber: params.phoneNumber,
  //   faxNumberCountryId: params.faxNumberCountryId,
  //   faxNumber: params.faxNumber,
  //   email: params.email,
  //   organizationLogoUrl: params.organizationLogoUrl,
  //   currencyId: params.currencyId
  // }
}
export default { request }
